let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ecqaz"), load("cC68k")]).then(() => parcelRequire('iI06X'));